// extracted by mini-css-extract-plugin
export default {"container":"D_SNK"};